import React from 'react';
import ISForm from './ISForm';

const SecondaryContent = () => {
  return <ISForm />;
};

export default React.memo(SecondaryContent);
